function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("line", {
  id: "Line_113",
  "data-name": "Line 113",
  x2: 36,
  transform: "translate(1 1.5)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_67",
  "data-name": "Ellipse 67",
  cx: 1.5,
  cy: 1.5,
  r: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_68",
  "data-name": "Ellipse 68",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  transform: "translate(12)"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_69",
  "data-name": "Ellipse 69",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  transform: "translate(18)"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_70",
  "data-name": "Ellipse 70",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  transform: "translate(35)"
});

var SvgIconMulti = function SvgIconMulti(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_83",
    "data-name": "Group 83",
    width: 38,
    height: 3,
    viewBox: "0 0 38 3",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconMulti, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_multi.98588539.svg";
export { ForwardRef as ReactComponent };